<template>
  <div class="d-flex search-container">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="menu-wrapper"
          :style="{ height: height }"
        >
          {{ selectMenu }}
          <v-icon>mdi-chevron-down</v-icon>
        </div>
      </template>
      <v-list>
        <v-list-item
          v-for="(menu, index) in menuList"
          :key="index"
          @click="selectMenu = menu"
        >
          <v-list-item-title>{{ menu }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <div class="d-flex align-center input-wrapper" :style="{ height: height }">
      <input
        :value="searchInput"
        @keydown.enter="onEnterSearch"
        @input="onInput"
      />
      <button type="button" @click="onClickSearch" class="pl-1 pr-2">
        <v-icon color="#556C96">mdi-magnify</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: { Type: String, default: "40px", require: false },
    list: {
      Type: Array,
      require: false,
      default: () => {
        return ["발주차수", "부위"];
      },
    },
  },
  data: () => ({
    menuList: [],
    selectMenu: null,
    searchInput: null,
  }),
  mounted() {
    this.menuList = [...this.list];
    this.selectMenu = this.list[0];
  },
  methods: {
    onInput(e) {
      const value = e.target.value;
      this.searchInput = value;
      if (value.length === 0) {
        this.$emit("on-reset-input");
      }
    },
    onEnterSearch(e) {
      this.searchInput = e.target.value;
      this.$emit("on-search-input", {
        type: this.selectMenu,
        value: e.target.value,
      });
    },
    onClickSearch() {
      this.$emit("on-search-input", {
        type: this.selectMenu,
        value: this.searchInput,
      });
    },
    /** 메뉴/인풋 리셋 - 부모에서 사용 */
    onResetInput() {
      this.selectMenu = this.list[0];
      this.searchInput = null;
    },
  },
};
</script>

<style scoped lang="scss">
* {
  font-size: 14px;
  font-family: "Noto Sans KR";
}
.search-container {
  border: 1px solid #9e9e9e;
  border-radius: 5px;
}
.menu-wrapper {
  width: 100px;
  height: 40px;
  border-right: 1px solid #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 5px 0px 10px;
}
.input-wrapper {
  > input {
    width: 220px;
  }
}
</style>
